import { useEffect, useRef, useState } from "react";

import getImgUrl from "../../helper/getImgUrl";
import styles from "../dash_styles/productedit.module.css";
import api from '../../api/axios';

import { GoUpload } from "react-icons/go";


const ProductEdit = () => {
    const [materialsInput, setMaterialsInput] = useState([]);
    const [newImages, setNewImages] = useState({});
    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [imagePreviews, setImagePreviews] = useState({});
    const [formData, setFormData] = useState({
        title: selectedProduct?.title || '',
        type: selectedProduct?.type || '',
        price: selectedProduct?.price || '',
        productdesc: selectedProduct?.productdesc || '',
        quantity: selectedProduct?.quantity || '',
        cost: selectedProduct?.cost || ''
    });
    
    const carouselRef = useRef();
    const fileInputRefs = useRef([]);


    const fetchProducts = async () => {
        try {
            const response = await api.get('/product/list');
            setProducts(response.data);
        } catch (error) {
            console.error('Error fetching products:', error);
        } 
    };
    
    useEffect(() => {
        fetchProducts();
    }, []);

    useEffect(() => {
        if (!selectedProduct) return;

        setFormData({
            title: selectedProduct.title || '',
            type: selectedProduct.type || '',
            price: selectedProduct.price || '',
            productdesc: selectedProduct.productdesc || '',
            quantity: selectedProduct.quantity || '',
            cost: selectedProduct.cost || ''
        });
        setMaterialsInput(selectedProduct.materials || []);
    }, [selectedProduct]);

    useEffect(() => {
        const carousel = carouselRef.current;
        if (!carousel) return;

        const handleWheel = (e) => {
            e.preventDefault();
            carousel.scrollLeft += e.deltaY;
        };

        carousel.addEventListener("wheel", handleWheel);

        return () => {
            carousel.removeEventListener("wheel", handleWheel);
        };
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value}));
    };

    const handleUploadClick = (index) => {
        fileInputRefs.current[index].click();
    };

    const handleMatrialsChange = (e) => setMaterialsInput(e.target.value);

    const handleImgageChange = (e, index) => {
        const file = e.target.files[0];
        if (file) {
            setNewImages(prev => ({ ...prev, [index]: file }));
            setImagePreviews(prev => ({ ...prev, [index]: URL.createObjectURL(file) }));
        }
    };

    const handleUpdateProduct = async (e) => {
        e.preventDefault();
        try {
            const data = new FormData();

            data.append('id', formData.id);
            data.append('title', formData.title);
            data.append('price', formData.price);
            data.append('type', formData.type);
            data.append('productdesc', formData.productdesc);
            data.append('quantity', formData.quantity);
            data.append('cost', formData.cost);

            materialsInput.forEach(m => data.append('materials', m));

            Object.entries(newImages).forEach(([index, file]) => {
                data.append('replaceIndexes', index);
                data.append('images', file);
            });

            const response = await api.put(
                '/productmgmt/update',
                data,
                { headers: { 'Content-Type': 'multipart/form-data'} }
            );
            await fetchProducts();
            console.log('Update successful:', response.data);
            alert(`${formData.title} updated successfully`);
        } catch (error) {
            console.error('Error updating product:', error);
            alert('Failed to update product');
        }
    };

    console.log(selectedProduct);
    return (
        <div className={styles.mainContainer}>
            <div className={styles.productCarousel} ref={carouselRef}>
                {Array.isArray(products) && products.map(product => (
                    <div key={product.id} className={styles.productContainer} onClick={() => setSelectedProduct(product)}>
                        <div className={styles.imgCard}>
                            <img 
                                src={getImgUrl(product.images[0], 'product')}
                                alt="product preview"
                            />
                        </div>
                        <div className={styles.productInfo}>
                            <div className={styles.detailsContainer}>
                                <p>{product.title}</p>
                            </div>
                            <div className={styles.detailsContainer}>
                                <p>{product.type}</p>
                            </div>
                        </div>
                        
                    </div>
                ))}
            </div>
            {selectedProduct ? (
                <div className={styles.mainEdit}>
                    <div className={styles.left}>
                        <div className={styles.product}>
                            <div className={styles.top}>
                                <div className={styles.title}>
                                    <p>Product details</p>
                                </div>
                                <button type="submit" form="updateProductForm">Save Changes</button>
                            </div>
                            
                            <div className={styles.productEditFormContent}>
                                <div className={styles.media}>
                                    <img src={getImgUrl(selectedProduct.images[0], 'product')} alt=""/>
                                </div>
                                <form className={styles.productFormContent} onSubmit={handleUpdateProduct} id="updateProductForm">
                                    
                                    <div className={styles.inputBox}>
                                        <p>Product name</p>
                                        <input
                                            type="text"
                                            name="title"
                                            placeholder="Enter name of product"
                                            value={formData.title}
                                            onChange={handleInputChange}
                                            maxLength={50}
                                        />
                                    </div>
                                    <div className={styles.inputBox}>
                                        <p>product type</p>
                                        <input
                                            name="type"
                                            type="text"
                                            placeholder="Enter product type"
                                            value={formData.type}
                                            onChange={handleInputChange}
                                            maxLength={50}
                                        />
                                    </div>
                                    <div className={styles.inputBox}>
                                        <p>product price</p>
                                        <input
                                            name="price"
                                            type="text"
                                            placeholder="Enter price of product"
                                            value={formData.price}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className={styles.inputBox}>
                                        <p>cost of product</p>
                                        <input
                                            name="cost"
                                            type="text"
                                            placeholder="Enter cost of product"
                                            value={formData.cost}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className={styles.inputBox}>
                                        <p>material available</p>
                                        <input
                                            name="materials"
                                            type="text"
                                            placeholder="Enter material available"
                                            value={materialsInput}
                                            onChange={handleMatrialsChange}
                                        />
                                    </div>
                                    <div className={styles.inputBox}>
                                        <p>stock quantity</p>
                                        <input
                                            name="quantity"
                                            type="number"
                                            placeholder="Stock availabilty"
                                            value={formData.quantity}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className={styles.inputBoxArea}>
                                        <p>Product description</p>
                                        <textarea 
                                            name="productdesc"
                                            placeholder="Describe the product"
                                            value={formData.productdesc}
                                            onChange={handleInputChange}
                                            maxLength={370}
                                            className={styles.textareaAdd}
                                        ></textarea>
                                    </div>
                                </form>
                                
                            </div>
                        </div>
                        <div>
                            <div className={styles.productMedia}>
                                <div className={styles.title}><p>Product Media</p></div>
                                <div className={styles.innerMedia}>
                                    <div className={styles.inputBoxMedia}>
                                        <p>Main Photo</p>
                                        <img src={imagePreviews[0] || getImgUrl(selectedProduct.images[0], 'product')} alt="Preview"/>
                                        <div onClick={() => handleUploadClick(0)} className={styles.customeUploader}> 
                                            <GoUpload/> <h4 className={styles.special}>Upload Image</h4>
                                        </div>
                                        <input
                                            name="images"
                                            type="file"
                                            ref={(el) => (fileInputRefs.current[0] = el)}
                                            className={styles.hiddenFileInput}
                                            onChange={(e) => handleImgageChange(e, 0)}
                                        />
                                    </div>
                                    <div className={styles.inputBoxMedia}>
                                        <p>second Photo</p>
                                        <img src={imagePreviews[1] || getImgUrl(selectedProduct.images[1], 'product')} alt="Preview"/>
                                        <div onClick={() => handleUploadClick(1)} className={styles.customeUploader}> 
                                            <GoUpload/> <h4 className={styles.special}>Upload Image</h4>
                                        </div>
                                        <input
                                            name="images"
                                            type="file"
                                            ref={(el) => (fileInputRefs.current[1] = el)}
                                            className={styles.hiddenFileInput}
                                            onChange={(e) => handleImgageChange(e, 1)}
                                        />
                                    </div>
                                    <div className={styles.inputBoxMedia}>
                                        <p>third Photo</p>
                                        <img src={imagePreviews[2] || getImgUrl(selectedProduct.images[2], 'product')} alt="Preview"/>
                                        <div onClick={() => handleUploadClick(2)} className={styles.customeUploader}> 
                                            <GoUpload/> <h4 className={styles.special}>Upload Image</h4>
                                        </div>
                                        <input
                                            name="images"
                                            type="file"
                                            ref={(el) => (fileInputRefs.current[2] = el)}
                                            className={styles.hiddenFileInput}
                                            onChange={(e) => handleImgageChange(e, 2)}
                                        />
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.right}>
                        <div className={styles.productNotes}>
                            <div className={styles.notesHeader}>
                                <div className={styles.titles}><p>notes</p></div>
                                <button>Add note</button>
                            </div>
                            <div className={styles.notesBody}>

                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className={styles.selectProduct}>
                    <p>Select a product from the carousel to begin</p>
                    <p style={{ fontWeight: 400, marginTop: '10px'}}>Edit products</p>
                </div>
            )}
            
        </div>
    )
};

export default ProductEdit;